export default {
    checkInOutApproval: 'การอนุมัติคำขอลงเวลา',
    firstLastName: 'ชื่อจริง - นามสกุล',
    requestType: 'ประเภทคำขอ',
    startDate: 'วันที่สร้าง',
    forgetDate: 'วันที่ลืมลงเวลา',
    pending: 'รอดำเนินการ',
    processed: 'ดำเนินการแล้ว',
    checkInTime: 'เวลาเข้างาน',
    checkOutTime: 'เวลาออกงาน',
    description: 'รายละเอียดคำขอ',
    back: 'ย้อนกลับ',
    reject: 'ไม่อนุมัติ',
    approve: 'อนุมัติ',
    cannotGetLineId: 'เกิดข้อผิดพลาด'
}
